import type { ReactNode } from 'react';

import './Label.css';

type LabelTone = 'meta' | 'ink' | 'ink-2' | 'blue' | 'amber' | 'on-blue';

interface LabelProps {
  children: ReactNode;
  /** Default 'meta' is --ink-3, the metadata grey. */
  tone?: LabelTone;
  /** Mono for identifiers: FM ids, section refs, report numbers. */
  mono?: boolean;
  as?: 'span' | 'div' | 'p' | 'h2' | 'h3' | 'dt';
  className?: string;
}

export default function Label({
  children,
  tone = 'meta',
  mono = false,
  as: Tag = 'span',
  className,
}: LabelProps) {
  const classes = [
    'label',
    tone === 'meta' ? null : `label--${tone}`,
    mono ? 'label--mono' : null,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return <Tag className={classes}>{children}</Tag>;
}
